import { StoreState } from "store/index";

export const getIndexCampaigns = (state: StoreState) => state.indexCampaigns;
